import {
  useEffect,
  useState,
  lazy,
  Suspense,
  useCallback,
  useLayoutEffect,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { Routes, BrowserRouter, Route } from "react-router-dom";
import { StaticRouter } from 'react-router-dom/server';
// import { PostHogProvider } from "posthog-js/react";
// import { initFacebookPixel } from "./components/Utility/FacebookPixel.js";
import theme from "./theme.js";
import AccessRestriced from "./components/Utility/AccessRestriced.jsx";
import Loader from "./components/Utility/Loader.jsx";
import Footer from "./components/Footer/Footer.jsx";
import SSPnew from "./components/SSPnew1/SSPnew.jsx";
import Investment from "./components/investment/Investment.jsx";
import { applySeoToDocument } from "./seo/pageSeo.js";
import NotFound from "./components/Utility/NotFound.jsx";

// const Main = lazy(() => import("./components/Main.jsx"));
const AboutUs = lazy(() => import("./components/AboutUs/AboutUs.jsx"));
const RefundAndCancellation = lazy(() => import("./components/RefundAndCancellation/RefundAndCancellation.jsx"));
const Policy = lazy(() => import("./components/Policy/Policy.jsx"));
const TermsAndConditions = lazy(() => import("./components/TermsAndConditions/TermsAndConditions.jsx"));
const Careers = lazy(() => import("./components/Careers/Careers.jsx"));
const ContactUs = lazy(() => import("./components/ContactUs/ContactUs.jsx"));
const MeRewards = lazy(() => import("./components/MeRewards/MeRewards.jsx"));
const MeetTheTeam = lazy(() => import("./components/MeetTheTeam/MeetTheTeam.jsx"));
const Dl = lazy(() => import("./components/Dl/Dl.jsx"));
const Investor = lazy(() => import("./components/Investor/Investor.jsx"));
const InvestInPM = lazy(() => import("./components/Investor/InvestInPM.jsx"));
const InvestInPMProd = lazy(() => import("./components/Investor/InvestInPMProd.jsx"));

const IS_PROD = import.meta.env.VITE_ENVIRONMENT === "Production";
import InvestorGate from "./components/Investor/InvestorGate.jsx";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

// const FloatingOpenApp = lazy(() =>
//   import("./components/Utility/FloatingOpenApp.jsx")
// );

// Registering GSAP Plugin
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const HOME_PAGE_EVENT = "home_page_view";
const PLAYSTORE_REDIRECT_EVENT = "pm_playstore_redirect_event";
const APPSTORE_REDIRECT_EVENT = "pm_appstore_redirect_event";
const ENABLE_COUNTRY_GATING = false;
// const POSTHOG_KEY = "phc_jTsMWwxizgNvwFmTI7OnQd8W20QVWoMrPDfkwl39TSO";
// const POSTHOG_HOST = "https://us.i.posthog.com";

// const initPostHog = async () => {
//   try {
//     const { default: posthog } = await import("posthog-js");
//     posthog.init(POSTHOG_KEY, {
//       api_host: POSTHOG_HOST,
//       person_profiles: "always",
//       loaded: (loadedPosthog) => {
//         if (import.meta.env.DEV) loadedPosthog.opt_out_capturing();
//       },
//       autocapture: false,
//     });
//     return posthog;
//   } catch (error) {
//     console.error("Failed to initialize PostHog:", error);
//     return null;
//   }
// };

const Router = typeof window !== "undefined" ? BrowserRouter : StaticRouter;

const App = ({ url }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  // const [posthog, setPosthog] = useState(null);
  const [country, setCountry] = useState("India");
  const [loading, setloading] = useState(false);

  // --PostHog--
  // useEffect(() => {
  //   const initializeAnalytics = () => {
  //     const backgroundTask = async () => {
  //       const posthogInstance = await initPostHog();
  //       setPosthog(posthogInstance);
  //     };

  //     if (window.requestIdleCallback) {
  //       window.requestIdleCallback(
  //         () => {
  //           backgroundTask();
  //         },
  //         { timeout: 10000 }
  //       );
  //     } else {
  //       setTimeout(backgroundTask, 0);
  //     }
  //   };

  //   initializeAnalytics();
  //   initFacebookPixel("552411717563607"); // Replace with your Pixel ID
  // }, []);

  // const triggerGTMEvent = (eventName) => {
  //   logEvent(analytics, eventName);
  // }

  // const triggerPlaystoreRedirectEvent = () => {
  //   logEvent(analytics, PLAYSTORE_REDIRECT_EVENT);
  // };

  // const triggerAppstoreRedirectEvent = () => {
  //   logEvent(analytics, APPSTORE_REDIRECT_EVENT);
  // };

  const checkLoginStatus = useCallback(() => {
    // Skip during SSR
    if (typeof window === "undefined") {
      setLoggedIn(true);
      setloading(false);
      return;
    }

    const lastLoginTime = localStorage.getItem("llt");
    const currentTime = new Date().getTime();
    const tenMinutes = 10 * 60 * 1000;

    let shouldLogin = false;
    if (lastLoginTime && currentTime - lastLoginTime < tenMinutes) {
      localStorage.setItem("llt", currentTime.toString());
      shouldLogin = true;
    } else {
      const isStaging = [
        "staging",
        "swap-vc.web.app",
        "swap-vc.firebaseapp.com",
        "localhost",
      ].some((str) => window.location.href.includes(str));
      if (isStaging) {
        handleStagingLogin(currentTime);
        return;
      } else {
        shouldLogin = true;
      }
    }

    setLoggedIn(shouldLogin);
  }, []);

  useEffect(() => {
    checkLoginStatus();
  }, []);

  const handleStagingLogin = (currentTime) => {
    const id = prompt("Enter ID");
    if (id === import.meta.env.VITE_APP_USERNAME) {
      const password = prompt("Enter password");
      if (password === import.meta.env.VITE_APP_PASSWORD) {
        setLoggedIn(true);
        localStorage.setItem("llt", currentTime.toString());
      } else {
        handleLoginFailure();
      }
    } else {
      handleLoginFailure();
    }
  };

  const handleLoginFailure = () => {
    alert("Wrong Id");
    localStorage.removeItem("llt");
    window.location.reload();
  };

  const fetchCountry = async () => {
    // Skip during SSR
    if (typeof window === "undefined") {
      setloading(false);
      return;
    }

    
    if (import.meta.env.VITE_ENVIRONMENT !== "Production") {
      console.log("Skipping fetchCountry in non-production environment");
      setloading(false);
      return;
    }

    try {
      const response = await fetch(
        `https://ipgeolocation.abstractapi.com/v1/?api_key=${import.meta.env.VITE_ABSTRACT_API_KEY
        }`
      );
      if (!response.ok) {
        throw new Error("Abstract API limit reached or request failed");
      }
      const data = await response.json();
      console.log(data);
      if (data.country) {
        setCountry(data.country);
        console.log(data.country);
      }
    } catch (error) {
      console.error("Error fetching IP address:", error);
      return null;
    } finally {
      setloading(false);
    }
  };

  const changeLanguage = () => {
    // const detectedLanguage = i18n.language
    // console.log("===>" , detectedLanguage)
    // i18n.changeLanguage(detectedLanguage)
  };

  // useEffect(() => {
  // const storedLanguage = sessionStorage.getItem("i18nextLng");
  // if (storedLanguage) {
  //   i18n.changeLanguage(storedLanguage);
  // } else {
  //   changeLanguage();
  // }
  // }, []);

  useEffect(() => {
    fetchCountry();
  }, []);

  // Initalize `Analytics` once user loggedin
  useEffect(() => {
    if (typeof window === "undefined") return;

    const initializeServices = async () => {
      console.log("inializing firebase Analytics");
      try {
        // Dynamically import Firebase and analytics
        const { getAnalytics, logEvent } = await import("firebase/analytics");
        const ReactGA = (await import("react-ga4")).default;
        const { webApp, firebaseConfig } = await import("./firebase.js");

        // Initialize analytics
        const analytics = getAnalytics(webApp);
        ReactGA.initialize(firebaseConfig.measurementId);

        // Log home page event if logged in
        if (loggedIn) {
          logEvent(analytics, HOME_PAGE_EVENT);
        }
      } catch (error) {
        console.error("Failed to initialize services:", error);
      }
    };

    initializeServices();
  }, [loggedIn]);

  if (loading) {
    return <Loader />;
  }

  if (!loggedIn) {
    return <Loader />;
  }

  if (ENABLE_COUNTRY_GATING && country !== "India") {
    return <AccessRestriced />;
  }

  return (
    <>
      {/* <PostHogProvider client={posthog}>  */}
      <ThemeProvider theme={theme}>
        <Router location={url}>
          <AppContent
          // triggerAppstoreRedirectEvent={triggerAppstoreRedirectEvent}
          // triggerPlaystoreRedirectEvent={triggerPlaystoreRedirectEvent}
          // triggerGTMEvent={triggerGTMEvent}
          />
        </Router>
      </ThemeProvider>
      {/* </PostHogProvider> */}
    </>
  );
};

const AppContent = (
  {
    // triggerAppstoreRedirectEvent,
    // triggerPlaystoreRedirectEvent,
    // triggerGTMEvent
  }
) => {
  const location = useLocation();
  const smootherRef = useRef(null);
  const isInitialized = useRef(false);
  const currentPath = location.pathname;
  // const searchParams = new URLSearchParams(location.search);

  const searchParams =
    typeof window !== "undefined"
      ? new URLSearchParams(location.search)
      : new URLSearchParams();

  const isMobile = searchParams.get("isMobile") === "true";
  // console.log("is mobile = ", isMobile);

  const alwaysHideFooterRoutes = ["/dl", "/me"];
  const shouldHideFooter =
    alwaysHideFooterRoutes.includes(currentPath) ||
    (isMobile &&
      (currentPath === "/termsAndConditions" ||
        currentPath === "/privacyPolicy"));

  const hideFooterInStartsWithPath =
    currentPath.startsWith("/me") || currentPath.startsWith("/dl");

  useEffect(() => {
    applySeoToDocument(currentPath);
  }, [currentPath]);

  useLayoutEffect(() => {
    if (typeof window === "undefined") return;

    const container = document.querySelector(".gsap-animation-container");
    if (container) {
      ScrollTrigger.defaults({
        toggleActions: "restart pause resume pause",
        scroller: ".gsap-animation-container",
      });
    } else {
      console.log(
        "gsap-animation-container not found when initializing ScrollTrigger."
      );
    }

    return () => {
      ScrollTrigger.killAll();
    };
  }, []);

  // Use this for: Smooth Scrolling with below 👇 Preffered containers
  useLayoutEffect(() => {
    if (typeof window === "undefined") return;
    // -- Scroll Smoothing via GSAP--
    const allowedSmoothScrollList = ["/"];
    const isHomePage = allowedSmoothScrollList.includes(currentPath);

    if (isHomePage && !isInitialized.current) {
      const smoother = ScrollSmoother.create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        smooth: 1.6,
        smoothTouch: 0,
        effects: true,
        ignoreMobileResize: true,
        normalizeScroll: {
          allowNestedScroll: true, // Allow nested scrolling
        },
      });

      smootherRef.current = smoother;
      isInitialized.current = true;

      ScrollTrigger.config({
        limitCallbacks: true,
        ignoreMobileResize: true,
        autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
      });

      if (window.requestIdleCallback) {
        window.requestIdleCallback(() => {
          ScrollTrigger.refresh();
        });
      } else {
        // Fallback with delayed timeout
        setTimeout(() => {
          ScrollTrigger.refresh();
        }, 200);
      }

      return () => {
        if (smoother) {
          smoother.kill();
          isInitialized.current = false;
        }
      };
    }
    if (!isHomePage && isInitialized.current && smootherRef.current) {
      smootherRef.current.kill();
      isInitialized.current = false;
    }
  }, [currentPath]);

  const renderContent = () => {
    return (
      // Preffer: for Snap Sections + with GSAP Animations
      // <div className="w-full h-screen overflow-y-auto snap-mandatory snap-y gsap-animation-container no-scrollbar">
      //   <Suspense fallback={<Loader />}>
      //     <Routes>
      //       <Route
      //         path="/"
      //         element={
      //           <Main
      //             triggerAppstoreRedirectEvent={triggerAppstoreRedirectEvent}
      //             triggerPlaystoreRedirectEvent={triggerPlaystoreRedirectEvent}
      //           />
      //         }
      //       />
      //       <Route path="/aboutUs" element={<AboutUs />} />
      //       <Route path="/ssp" element={<SSP />} />
      //       <Route path="/privacyPolicy" element={<Policy />} />
      //       <Route
      //         path="/termsAndConditions"
      //         element={<TermsAndConditions />}
      //       />
      //       <Route
      //         path="/refundAndCancellation"
      //         element={<RefundAndCancellation />}
      //       />
      //       <Route path="/careers" element={<Careers />} />
      //       <Route path="/contact" element={<ContactUs />} />
      //       <Route path="/faq" element={<FAQs />} />
      //       <Route
      //         path="/me/:shareableEarningsId/:name"
      //         element={<MeRewards />}
      //       />
      //       <Route path="/dl/*" element={<Dl />} />
      //       <Route path="*" element={<Main />} />
      //     </Routes>
      //     {!shouldHideFooter && !hideFooterInStartsWithPath && <Footer />}
      //     {!isMobile && <FloatingOpenApp />}
      //   </Suspense>
      // </div>

      // Preffer: Only Smoothe Scrolling + GSAP Animations & NO Snap Sections
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <Suspense fallback={<Loader />}>
            <Routes>
              {/* <Route path="/" element={<SSPf />} /> */}
              {/* <Route path="/" element={<SSPnew />} /> */}
              <Route path="/" element={<SSPnew />} />
              {/* <Route path="/investment" element={<Investment />} /> */}
              {/* Prod: /investor → InvestInPMProd, /investInPM → 404
                  Staging: /investor → Investor, /investInPM → InvestInPM */}
              <Route
                path="/investor"
                element={
                  IS_PROD
                    ? <InvestorGate><InvestInPMProd /></InvestorGate>
                    : <InvestorGate><Investor /></InvestorGate>
                }
              />
              {!IS_PROD && (
                <Route path="/investInPM" element={<InvestorGate><InvestInPM /></InvestorGate>} />
              )}
              {!IS_PROD && (
                <Route path="/investInPMProd" element={<InvestorGate><InvestInPMProd /></InvestorGate>} />
              )}
              <Route path="/aboutUs" element={<AboutUs />} />
              <Route path="/meetTheTeam" element={<MeetTheTeam />} />
              <Route path="/privacyPolicy" element={<Policy />} />
              <Route path="/termsAndConditions" element={<TermsAndConditions />} />
              <Route path="/refundAndCancellation" element={<RefundAndCancellation />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/me/:shareableEarningsId/:name" element={<MeRewards />} />
              <Route path="/dl/*" element={<Dl />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
           {!shouldHideFooter &&
  !currentPath.startsWith("/me/") &&
  !currentPath.startsWith("/investor") &&
  !currentPath.startsWith("/investInPM") &&
  !currentPath.startsWith("/investInPMProd") &&
  (
    <Footer
      dark={
        currentPath === "/" ||
        currentPath.startsWith("/investment")
      }
    />
  )
}
            {/* {!isMobile && <FloatingOpenApp />} */}
          </Suspense>
        </div>
      </div>
    );
  };
  return renderContent();
};

export default App;
